export default __webpack_public_path__ + "static/media/instruction-manuals-book.0f3c6785.jpg";